import http from "./httpService";
import { apiUrl } from "../../config.js";
import { DateTime } from "luxon";

const apiEndpoint = apiUrl + "/users/";

export function getDocumentApprovalProcess(appCode = "", docID = "") {
  return http.get(
    apiEndpoint + `document-approval-process/${appCode}/${docID}`
  );
}

export function getUsers(salesUser = "-") {
  return http.get(apiEndpoint + "user-list/" + salesUser);
}

export function getUserMasterDataAPI() {
  return http.get(apiEndpoint + "user-master-data");
}

export function getUser(userID) {
  return http.get(apiEndpoint + "user/" + userID);
}

export function saveUser(user) {
  if (user.ID === 0) {
    return http.post(apiEndpoint, user);
  } else {
    return http.put(apiEndpoint, user);
  }
}

export function saveUserNewPassword(user) {
  if (user.ID === 0) {
    return http.post(apiEndpoint, user);
  } else {
    return http.put(apiEndpoint + "newpassword/", user);
  }
}

export function saveUserAvatar(files) {
  return http.post(apiEndpoint + "avatar", files);
}

export function generateSendCorePlatformAccess(user) {
  return http.post(apiEndpoint + "generate-send-core-platform-access", user);
}

export function deleteUser(userID) {
  return http.delete(apiEndpoint + "user/" + userID);
}

export function restoreUser(userID) {
  return http.put(apiEndpoint + "user/" + userID);
}

export function getUserPreferences(userID) {
  return http.get(apiEndpoint + "user-preferences/" + userID);
}

export function saveUserPreferences(userPreferences) {
  if (userPreferences.ID === 0) {
    return http.post(apiEndpoint + "user-preferences", userPreferences);
  } else {
    return http.put(apiEndpoint + "user-preferences", userPreferences);
  }
}

export function lockUser(userID) {
  return http.put(apiEndpoint + "user-lock/" + userID);
}

export function unlockUser(userID) {
  return http.put(apiEndpoint + "user-unlock/" + userID);
}

export function massLockUser() {
  return http.put(apiEndpoint + "user-mass-lock");
}

export function massUnlockUser() {
  return http.put(apiEndpoint + "user-mass-unlock");
}

export function getUsersOfUserGroup(groupID) {
  return http.get(apiEndpoint + "users-user-group/" + groupID);
}

export function getUserGroups() {
  return http.get(apiEndpoint + "user-group");
}

export function getUserGroup(groupID) {
  return http.get(apiEndpoint + "user-group/" + groupID);
}

export function deleteUserGroup(userGroupID) {
  return http.delete(apiEndpoint + "user-group/" + userGroupID);
}

export function saveUserGroup(userGroup) {
  if (userGroup.ID === 0) {
    return http.post(apiEndpoint + "user-group", userGroup);
  } else {
    return http.put(apiEndpoint + "user-group", userGroup);
  }
}

export function getSalesGroups() {
  return http.get(apiEndpoint + "sales-groups");
}

export function getAuthorizations() {
  return http.get(apiEndpoint + "authorization");
}

export function deleteAuthorization(authID = 0) {
  return http.delete(apiEndpoint + "authorization/" + authID);
}

export function saveAuthorization(authorization) {
  return http.post(apiEndpoint + "authorization", authorization);
}

export function getAuthorizationTree(authID = 0) {
  return http.get(apiEndpoint + "authorization-tree/" + authID);
}

export function getAuthorizationDetail(authID) {
  return http.get(apiEndpoint + "authorization-detail/" + authID);
}

export function getPendingApprovals() {
  return http.get(apiEndpoint + "pending-approvals");
}

export function getPendingApproval(approvalProcessID = 0) {
  return http.get(apiEndpoint + "pending-approval/" + approvalProcessID);
}

export function deleteApproval(approvalID = 0) {
  return http.delete(apiEndpoint + "approval/" + approvalID);
}

export function getApprovals() {
  return http.get(apiEndpoint + "approval");
}

export function saveApproval(approval) {
  return http.post(apiEndpoint + "approval", approval);
}

export function getApprovalDetail(approvalID) {
  return http.get(apiEndpoint + "approval-detail/" + approvalID);
}

export function saveApprovalProcessAction(approvalAction) {
  return http.post(apiEndpoint + "approval-process-action", approvalAction);
}

export function saveMessage(messageType, message) {
  return http.post(apiEndpoint + "message/" + messageType, message);
}

export function getMessages(messageType) {
  return http.get(apiEndpoint + "messages/" + messageType);
}

export function updateMessage(message) {
  return http.put(apiEndpoint + "message", message);
}

export function getMessageDetail(messageID) {
  return http.get(apiEndpoint + "message-detail/" + messageID);
}

export function getReplies(messageID) {
  return http.get(apiEndpoint + "message-replies/" + messageID);
}

export function saveMessageReply(messageID, message) {
  return http.post(apiEndpoint + "message-reply", { messageID, message });
}

export function deleteMessage(messageType, messageID) {
  return http.delete(apiEndpoint + "message/" + messageType + "/" + messageID);
}

export function getTaskList(
  dateFrom = DateTime.now().startOf("day"),
  dateTo = DateTime.now().endOf("day"),
  userID = 0
) {
  return http.get(apiEndpoint + `tasks/${dateFrom}/${dateTo}/${userID}`);
}

export function saveTask(task) {
  return http.post(apiEndpoint + "tasks", task);
}

export function deleteTask(taskID = 0) {
  return http.delete(apiEndpoint + "tasks/" + taskID);
}

export function getTimeSheetTask(taskID) {
  return http.get(apiEndpoint + "timesheet-task/" + taskID);
}

export function getUserTimeSheetPeriod(fiscalYear, fiscalPeriod) {
  return http.get(apiEndpoint + `user-timesheet/${fiscalYear}/${fiscalPeriod}`);
}

export function saveTimeSheet(timesheet) {
  return http.post(apiEndpoint + "timesheet", timesheet);
}

export function submitTimeSheet(submitTimesheet) {
  return http.post(apiEndpoint + "submit-timesheet", submitTimesheet);
}

export function withDrawTimeSheet(withDrawTimesheet) {
  return http.post(apiEndpoint + "withdraw-timesheet", withDrawTimesheet);
}

export function getTask(taskID) {
  return http.get(apiEndpoint + "task/" + taskID);
}

export function saveSubTask(subTask) {
  return http.post(apiEndpoint + "sub-task", subTask);
}

export function getSubTasks(taskID) {
  return http.get(apiEndpoint + "sub-tasks/" + taskID);
}

export function updateSubTasks(subTasks) {
  return http.put(apiEndpoint + "sub-tasks", subTasks);
}

export function updateSubTask(subTask) {
  return http.put(apiEndpoint + "sub-task", subTask);
}

export function saveNotification(notification) {
  return http.post(apiEndpoint + "notification", notification);
}

export function getNotifications() {
  return http.get(apiEndpoint + "notifications");
}

export function updateNotification(notification) {
  return http.put(apiEndpoint + "notification", notification);
}

export function getNotificationDetail(notificationID) {
  return http.get(apiEndpoint + "notification-detail/" + notificationID);
}

export function getUserSalesWidget(fiscalYearID = 0) {
  return http.get(apiEndpoint + "user-sales-widget/" + fiscalYearID);
}

export function getUserApprovalsWidget() {
  return http.get(apiEndpoint + "user-approvals-widget");
}

export function getUserTasksWidget() {
  return http.get(apiEndpoint + "user-tasks-widget");
}
